import { render, staticRenderFns } from "./subjectRecordsTimeline.vue?vue&type=template&id=6d5d2462&"
import script from "./subjectRecordsTimeline.vue?vue&type=script&lang=ts&"
export * from "./subjectRecordsTimeline.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports